import T from 'prop-types';
import React from 'react';
import { Box } from '@acast/decibel';
import ProgressBar from 'shared/components/progress-bar';

const PendingUploadPane = ({ progress = 0, fileName = '...' }) => {
  const percent = Math.floor(progress * 100);

  return (
    <div className="pending-upload-pane">
      <span className="pending-upload-pane__label">
        Uploading: "{fileName}" ({percent}%)
      </span>
      <Box width="60%" mx="auto" mt={4} flexDirection="column" alignItems="center">
        <ProgressBar value={percent} />
      </Box>
    </div>
  );
};

PendingUploadPane.propTypes = {
  progress: T.number,
  fileName: T.string,
};

export default PendingUploadPane;
